import * as React from 'react';

//hook
import { useState } from 'react';
import { useApi } from '../hooks/useApi';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DialogProps } from '@mui/material/Dialog';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//mui icon
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from '@mui/icons-material/Close';

//type
import { addDriverReqType } from '../api/Host/type/AddDriverType';
import { driverProfileType } from '../api/completedRole/type/CompletedRoleType';


//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//api
import { PostAddDriverApi } from '../api/Host/PostAddDriverApi';
import { UpdateDriverApi } from '../api/Host/UpdateDriverApi';


//mui date piker
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//moment
import moment from 'moment';

//utils
import { convertUrlToFile } from '../utils/convertUrlToFile';

interface addDriverProps {
    selectedDriver?: driverProfileType | null
    setSelectedDriver?: (selectedDriver?: driverProfileType) => void
    openAddDriver: {open:boolean,scrollType: DialogProps['scroll']}
    setOpenAddDriver: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    setMyDriver:(element: driverProfileType[]) => void
    getMyDrivers: () => Promise<any>
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const AddDriver = ({selectedDriver, setSelectedDriver, openAddDriver, setOpenAddDriver, setMyDriver, getMyDrivers}:addDriverProps) => {
    const { t } = useTranslation();
    let {
        loading: addDriverLoading, 
        error: addDriverError, 
        HandlerApi: postAddDriver
       } = useApi(PostAddDriverApi, "Post")
    let {
        loading: updateDriverLoading, 
        error: updateDriverError, 
        HandlerApi: updateAddDrivers
       } = useApi(UpdateDriverApi, "Post")
    const [driverPichture, setDriverPichture] = useState<string>('')
    const [RoleLicenseFront, setRoleLicenseFront] = useState<string>('')
    const [RoleLicenseBack, setRoleLicenseBack] = useState<string>('')
    const [showPass, setShowPass] = useState<boolean>(false)
    const driverSchema = Yup.object().shape({
        full_name: Yup.string().required(t("full_name_required")),
        email: Yup.string().email(t("invalid_email")).required(t("email_required")),
        password: Yup.string().when([], {
            is: () => !selectedDriver,
            then: schema =>
            schema
                .min(8, t("password_lenght"))
                .required(t("password_required")),
            otherwise: schema =>
            schema.notRequired(),
        }),
        availability_status: Yup.string().when([], {
            is: () => selectedDriver,
            then: schema =>
            schema
            .oneOf(
                    ["available", "busy", "off"],
                    t("invalid_status")
                    ),
            otherwise: schema =>
            schema.notRequired(),
        }),
        phone: Yup.string()
        //test(name, message, testFunction)
        .test(
            "len",t("phone_lenght"),
            (value) => {
            if (!value) return false;
            const numberWithoutCode = value.slice(4);
            return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
            }
        ).required(t("phone_required")),
        hourly_desired_wage: Yup.number()
        .required(t("hourly_desired_wage_required"))
        .test("hourly_desired_wage_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        extra_hour_price: Yup.number()
        .required(t("extra_hour_price_required"))
        .test("extra_hour_price_required", t("the_number_must_be_greater_than_zero"), (value) => {
            if (!value) return false;
            return value > 0;
        }),
        preferred_start_time: Yup.mixed()
            .required(t("preferred_start_time_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "HH:mm").isValid()),
        preferred_end_time: Yup.mixed()
            .required(t("preferred_end_time_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "HH:mm").isValid()),
        picture: Yup.mixed()
            .required(t("picture_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        front_license_image_url: Yup.mixed()
            .required(t("front_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        background_license_image_url: Yup.mixed()
            .required(t("background_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
    })

    //start functions

    const handleSubmit = async (values: addDriverReqType)=> {
        const payload: any = { ...values };
        if (selectedDriver) {
            delete payload.password;
            console.log(payload)
            if ('picture' in payload && typeof payload.picture === "string") {
                payload.picture = await convertUrlToFile(payload.picture);
            }
            if ('front_license_image_url' in payload && typeof payload.front_license_image_url === "string") {
                payload.front_license_image_url = await convertUrlToFile(payload.front_license_image_url);
            }
            if ('background_license_image_url' in payload && typeof payload.background_license_image_url === "string") {
                payload.background_license_image_url = await convertUrlToFile(payload.background_license_image_url);
            }
            let result = await updateAddDrivers(payload, selectedDriver.id)
            if(result.data){
                setOpenAddDriver({open: false, scrollType: "paper"})
                let result = await getMyDrivers()
                setMyDriver(result.data)
                setDriverPichture('')
                setRoleLicenseFront('')
                setRoleLicenseBack('')
                setSelectedDriver?.(undefined)
            }
        }
        else {
            delete payload.availability_status
            let result = await postAddDriver(payload)
            if(result.data){
                setOpenAddDriver({open: false, scrollType: "paper"})
                let result = await getMyDrivers()
                setMyDriver(result.data)
                setDriverPichture('')
                setRoleLicenseFront('')
                setRoleLicenseBack('')
                setSelectedDriver?.(undefined)
            }
        }
    }
    const handleCloseDilaog = () => {
        setOpenAddDriver({open: false, scrollType: 'paper'})
        setSelectedDriver?.(undefined)
        setDriverPichture('')
        setRoleLicenseFront('')
        setRoleLicenseBack('')
    }

    //end functions

  return (
    <Dialog 
    open={openAddDriver.open}
    onClose={handleCloseDilaog}
    slots={{
    transition: Transition,
    }}
    disableRestoreFocus
    maxWidth="sm"
    fullWidth 
    >
        <div style={{padding: "16px 24px"}} className={`flex justify-between items-center`}>
            <DialogTitle className='!p-0'>
                {
                    selectedDriver
                    ?<p>{t("edit_driver") }</p>
                    :<p>{t(`add_new_driver`)}</p>
                }
            </DialogTitle>
            <IconButton
            className={`!bg-paretnerColor !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
            onClick={() => {
                setOpenAddDriver({open: false, scrollType: "paper"});
                setSelectedDriver?.(undefined)
            }}
            size="large"
            >
                <CloseIcon className='!text-white'/>
            </IconButton>
        </div>
        <DialogContent>
            <Formik
            enableReinitialize
            initialValues={{
                full_name: selectedDriver?.user?.full_name ||"",
                email: selectedDriver?.user?.email || "",
                phone: selectedDriver?.user?.phone || "",
                password: "",
                availability_status: selectedDriver?.availability_status || "",
                hourly_desired_wage: selectedDriver?.hourly_desired_wage || 0,
                extra_hour_price: selectedDriver?.extra_hour_price || 0,
                picture: selectedDriver?.picture_url || null,
                preferred_start_time: selectedDriver?.preferred_start_time || null,
                preferred_end_time: selectedDriver?.preferred_end_time || null,
                front_license_image_url: selectedDriver?.front_license_image_url || null,
                background_license_image_url: selectedDriver?.background_license_image_url || null,
            }}
            validationSchema={driverSchema}
            onSubmit={(values)=>handleSubmit(values)}
            >
            {({ values,touched, errors,setFieldValue, setFieldTouched}) => (
                <Form>
                    <div>
                        <div className="flex max-sm:flex-col gap-2 mt-2">
                            <Field
                            as={TextField}
                            name="full_name"
                            label={t("full_name")}
                            className="sm:w-1/2 w-full"
                            helperText={touched.full_name && errors.full_name ? errors.full_name : ""}
                            error={touched.full_name && Boolean(errors.full_name)}
                            />
                            <Field
                            as={TextField}
                            name="email"
                            type="email"
                            label={t("email")}
                            className="sm:w-1/2 w-full"
                            helperText={touched.email && errors.email ? errors.email : ""}
                            error={touched.email && Boolean(errors.email)}
                            />
                        </div>
                        <div className="mt-5 flex max-sm:flex-col gap-2">
                            <div className='sm:w-1/2'>
                                {
                                    selectedDriver
                                    ?
                                    <FormControl className='!w-full'>
                                        <InputLabel id="demo-simple-select-label">{t("availability_status")}</InputLabel>
                                        <Select
                                        label={t("availability_status")}
                                        value={values.availability_status}
                                        onChange={(e) =>
                                        setFieldValue("availability_status", e.target.value)
                                        }
                                        >
                                            <MenuItem value="available">{t("available")}</MenuItem>
                                            <MenuItem value="busy">{t("busy")}</MenuItem>
                                            <MenuItem value="off">{t("off")}</MenuItem>
                                        </Select>
                                        {touched.availability_status && errors.availability_status && (
                                            <p className="text-red-500 text-xs mt-1">
                                            {errors.availability_status}
                                            </p>
                                        )}
                                    </FormControl>
                                    :
                                    <Field
                                    as={TextField}
                                    name="password"
                                    type={showPass ? "text" : "password"}
                                    label={t("password")}
                                    className="w-full"
                                    autoComplete="password"
                                    helperText={touched.password && errors.password ? errors.password : ""}
                                    error={touched.password && Boolean(errors.password)}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton onClick={()=>setShowPass((prev)=>!prev)}>
                                            {showPass ? <Visibility/> : <VisibilityOff/>}
                                            </IconButton>
                                        ),
                                    }}
                                    />
                                }
                            </div>
                            <div>
                                <PhoneInput
                                country={"sy"}
                                onlyCountries={["sy"]}
                                disableDropdown={true}
                                enableSearch={true}
                                value={values.phone}
                                onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                                inputStyle={{
                                    borderRadius: "4px",
                                    width: "100%",
                                    height: "56px",
                                    border: touched.phone && errors.phone ? "1px solid red" : "",
                                }}
                                buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                                containerStyle={{
                                    display: "flex",
                                    flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                                }}
                                inputProps={{
                                    autoComplete: "phone",
                                }}
                                />
                                <div className="text-red-500 text-sm mt-1">
                                {touched.phone && errors.phone ? errors.phone : ""}
                                </div>
                            </div>
                        </div>
                        <div className="mt-5">
                            <div>
                                <Button
                                    component="label"
                                    className='!bg-paretnerColor !text-white !text-[11px] !capitalize'
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {t("profile_picture")}
                                    <VisuallyHiddenInput
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                        const file = event.target.files?.[0];
                                        if (file) {
                                        setFieldValue("picture", file);
                                        setDriverPichture(URL.createObjectURL(file));
                                        }
                                    }}
                                    />
                                </Button>
                            </div>
                            {/* Show selected image preview */}
                            { driverPichture
                                ? (
                                    <img
                                    src={driverPichture}
                                    alt="Profile picture preview"
                                    className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                    loading="lazy"
                                    decoding="async"
                                    />
                                ) 
                                :
                                selectedDriver?.picture_url 
                                    ? (
                                        // Show existing uploaded image from backend
                                        <img
                                        src={`${storageURL}/${selectedDriver?.picture_url}`}
                                        alt="Profile picture preview"
                                        className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                        loading="lazy"
                                        decoding="async"
                                        />
                                    ) 
                                    : null
                            }
                            <p className="text-[12px] mt-2 text-red-500">
                                    {touched.picture && errors.picture ? errors.picture : ""}
                            </p>
                        </div>
                    </div>
                    <div>
                        <DialogTitle className='!px-0'>
                            <p>{t("price_details")}</p>
                        </DialogTitle>
                        <div>
                            <div className='flex gap-2 max-sm:flex-col'>
                                <Field
                                    as={TextField}
                                    type="number"
                                    name="hourly_desired_wage"
                                    label={t("hourly_desired_wage")}
                                    className="sm:w-1/2 w-full !mb-2"
                                    helperText={touched.hourly_desired_wage && errors.hourly_desired_wage ? errors.hourly_desired_wage : ""}
                                    error={touched.hourly_desired_wage && Boolean(errors.hourly_desired_wage)}
                                />
                                <Field
                                    as={TextField}
                                    type="number"
                                    name="extra_hour_price"
                                    label={t("extra_hour_price")}
                                    className="sm:w-1/2 w-full !mb-2"
                                    helperText={touched.extra_hour_price && errors.extra_hour_price ? errors.extra_hour_price : ""}
                                    error={touched.extra_hour_price && Boolean(errors.extra_hour_price)}
                                />
                            </div>
                            <div className='flex gap-2 max-sm:flex-col'>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <TimePicker
                                    label={t("preferred_start_time")}
                                    format="HH:mm"
                                    closeOnSelect={false}
                                    value={values.preferred_start_time ? moment(values.preferred_start_time, "HH:mm") : null}
                                    onChange={(value) => {
                                        setFieldValue("preferred_start_time", value ? value.format("HH:mm") : null);
                                    }}
                                    onClose={() => {
                                        setFieldTouched("preferred_start_time", true);
                                    }}
                                    slotProps={{
                                        textField: {
                                            helperText: values.preferred_start_time === null && touched.preferred_start_time && errors.preferred_start_time ? errors.preferred_start_time : null,
                                            error: values.preferred_start_time === null && touched.preferred_start_time && Boolean(errors.preferred_start_time),
                                            className: "w-full"
                                        }
                                    }}
                                    />
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <TimePicker
                                    label={t("preferred_end_time")}
                                    format="HH:mm" 
                                    closeOnSelect={false}
                                    value={values.preferred_end_time ? moment(values.preferred_end_time, "HH:mm") : null}
                                    onChange={(value) => {
                                        setFieldValue("preferred_end_time", value ? value.format("HH:mm") : null);
                                    }}
                                    onClose={() => {
                                        setFieldTouched("preferred_end_time", true);
                                    }}
                                    slotProps={{
                                        textField: {
                                            helperText: values.preferred_end_time === null && touched.preferred_end_time && errors.preferred_end_time ? errors.preferred_end_time : null,
                                            error: values.preferred_end_time === null && touched.preferred_end_time && Boolean(errors.preferred_end_time),
                                            className: "w-full"
                                        }
                                    }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                    </div>
                    <div>
                        <DialogTitle className='!px-0'>
                            <p>{t("upload_documents")}</p>
                        </DialogTitle>
                        <div className="flex max-sm:flex-col max-sm:items-center gap-5">
                            <div>
                                <Button
                                    component="label"
                                    className='!bg-paretnerColor !text-white !text-[11px] w-fit !capitalize'
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {t("front_side")}
                                    <VisuallyHiddenInput
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                        const file = event.target.files?.[0];
                                        if (file) {
                                        setFieldValue("front_license_image_url", file);
                                        setRoleLicenseFront(URL.createObjectURL(file));
                                        }
                                    }}
                                    />
                                </Button>
                                {/* Show selected image preview */}
                                {RoleLicenseFront
                                    ? (
                                        <img
                                        src={RoleLicenseFront}
                                        alt="Front license preview"
                                        className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                        loading="lazy"
                                        decoding="async"
                                        />
                                    )
                                    :selectedDriver?.front_license_image_url 
                                        ? (
                                            // Show existing uploaded image from backend
                                            <img
                                            src={`${storageURL}/${selectedDriver?.front_license_image_url}`}
                                            alt="Front picture preview"
                                            className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                            loading="lazy"
                                            decoding="async"
                                            />
                                        ) 
                                        : null
                                }
                                <p className="text-[12px] mt-2 text-red-500">
                                    {touched.front_license_image_url && errors.front_license_image_url ? errors.front_license_image_url : ""}
                                </p>
                            </div>
                            <div>
                                <Button
                                    component="label"
                                    className='!bg-paretnerColor !text-white !text-[11px] w-fit !capitalize'
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {t("back_side")}
                                    <VisuallyHiddenInput
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                        const file = event.target.files?.[0];
                                        if (file) {
                                        setFieldValue("background_license_image_url", file);
                                        setRoleLicenseBack(URL.createObjectURL(file));
                                        }
                                    }}
                                    />
                                </Button>
                                {/* Show selected image preview */}
                                {RoleLicenseBack 
                                    ? (
                                        <img
                                        src={RoleLicenseBack}
                                        alt="Back license preview"
                                        className="mt-3 w-40 h-28 object-cover rounded-lg border max-sm:mx-auto"
                                        loading="lazy"
                                        decoding="async"
                                        />
                                    ) 
                                    :selectedDriver?.background_license_image_url
                                        ? (
                                            // Show existing uploaded image from backend
                                            <img
                                            src={`${storageURL}/${selectedDriver?.background_license_image_url}`}
                                            alt="Back picture preview"
                                            className="mt-3 w-40 h-28 object-cover rounded-lg border"
                                            loading="lazy"
                                            decoding="async"
                                            />
                                        ) 
                                        : null
                                }
                                <p className="text-[12px] mt-2 text-red-500">
                                    {touched.background_license_image_url && errors.background_license_image_url ? errors.background_license_image_url : ""}
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr className='mt-5'/>
                    <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                        <Button className='w-full !bg-paretnerColor !text-white !rounded-full' type="submit">
                            {addDriverLoading || updateDriverLoading
                            ? <CircularProgress className='w-1 h-1'/>
                            :selectedDriver ? t("update_driver") :t("confirm")
                            }
                        </Button>
                    </DialogActions>
                </Form>
            )}
            </Formik>
        </DialogContent>
    </Dialog>
  )
}

export default AddDriver